import React, { useEffect, useState } from 'react'
import { Form } from 'antd';
import { addMemberProfile, deleteMemberProfile, getMemberProfiles, updateMemberProfile } from '../../api/MemberProfileApi';
import AdnMessageError from '../common/adnMessage/AdnMessageError';
import AdnMessageSuccess from '../common/adnMessage/AdnMessageSuccess';
import MemberProfileForm from './MemberProfileForm';
import { appTitle } from "../common/GeneralConfigurations";

function ManageMemberProfilePage() {
    const [form] = Form.useForm();
    const [memberProfileData, setMemberProfileData] = useState([])
    const [loading, setLoading] = useState(true);
    const [event, setEvent] = useState("add");
    const [visible, setVisible] = useState(false);
    const [currPage, setCurrPage] = useState(1);
    const [orderBy, setOrderBy] = useState("");
    const [totalRecords, setTotalRecords] = useState([]);
    const [memberProfileHandler, setMemberProfileHandler] = useState();

    useEffect(() => {
        document.title = `${appTitle} - Member Profile List`;
        getMemberProfileData();
    }, [currPage]);

    const getMemberProfileData = async () => {
        await getMemberProfiles("", 0, false, currPage, orderBy).then((res) => {
            if (res.status == 200 && res.data.result) {
                setMemberProfileData(res.data.result);
                setTotalRecords(res.data.totalRecords);
                setLoading(false);
            } else {
                AdnMessageError();
                setLoading(false);
            }
        })
    }

    const submitMemberProfile = async (values) => {
        let base64ProfileDescription = Buffer.from(values.profileDescription).toString('base64');

        await getMemberProfiles(base64ProfileDescription, values.experience, true, currPage, orderBy).then(res => {
            if (res.status === 200) {
                if (event === "add") {
                    if (res.data.result.length === 0) {
                        addMemberProfile(values).then(res => {
                            if (res.status === 201 && res.data.success === true) {
                                setVisible(false);
                                getMemberProfileData();
                                AdnMessageSuccess();
                            } else {
                                AdnMessageError();
                            }
                        })
                        form.resetFields()
                    }
                    else {
                        AdnMessageError("This Profile already exists");
                    }
                } else if (event === "edit") {
                    values.id = memberProfileHandler?.id;
                    updateMemberProfile(values).then(res => {
                        if (res.status == 200 && res.data.success === true) {
                            setVisible(false);
                            getMemberProfileData();
                            AdnMessageSuccess();
                        } else {
                            AdnMessageError();
                        }
                    })
                }
            } else {
                AdnMessageError();
                setLoading(false);
            }
        })
    }

    const deleteMemberProfileData = (id) => {
        deleteMemberProfile(id).then(res => {
            if (res.status === 200) {
                getMemberProfileData();
                AdnMessageSuccess();
            } else {
                AdnMessageError();
            }
        })
    }

    const handleOrderList = (pag, filter, sorter) => {
        sorter.order === "descend"
            ? setOrderBy("-" + sorter.field)
            : sorter.order === "ascend"
                ? setOrderBy(sorter.field)
                : setOrderBy("");
    };

    return (
        <MemberProfileForm
            form={form}
            memberProfileData={memberProfileData}
            loading={loading}
            event={event}
            currPage={currPage}
            setCurrPage={setCurrPage}
            handleOrderList={handleOrderList}
            setEvent={setEvent}
            visible={visible}
            totalRecords={totalRecords}
            setVisible={setVisible}
            submitMemberProfile={submitMemberProfile}
            setMemberProfileHandler={setMemberProfileHandler}
            deleteMemberProfileData={deleteMemberProfileData}
        />
    );
}

export default ManageMemberProfilePage;
